import React from 'react';

const Portfolio = ({ onContactClick }) => {
  const projects = [
    {
      id: 1,
      icon: '🛒',
      category: 'E-Commerce Platform',
      title: 'Multi-Vendor Marketplace',
      description: 'Built a scalable e-commerce platform using React, Node.js, and MongoDB. Integrated payment gateways and real-time inventory management.',
      tags: ['React', 'Node.js', 'MongoDB', 'AWS']
    },
    {
      id: 2,
      icon: '📱',
      category: 'Mobile Application',
      title: 'Fitness Tracking App',
      description: 'Developed cross-platform mobile app with AI-powered workout recommendations and real-time health monitoring using React Native.',
      tags: ['React Native', 'AI/ML', 'Firebase']
    },
    {
      id: 3,
      icon: '🏢',
      category: 'Enterprise Solution',
      title: 'HR Management System',
      description: 'Modernized legacy HR system with Next.js frontend and microservices architecture. Reduced processing time by 70%.',
      tags: ['Next.js', 'Microservices', 'PostgreSQL']
    },
    {
      id: 4,
      icon: '📊',
      category: 'Analytics Dashboard',
      title: 'Business Intelligence Platform',
      description: 'Created real-time analytics dashboard with interactive visualizations and predictive insights using modern web technologies.',
      tags: ['React', 'D3.js', 'Python', 'AWS']
    },
    {
      id: 5,
      icon: '🎓',
      category: 'EdTech Platform',
      title: 'Online Learning Management',
      description: 'Developed comprehensive LMS with video streaming, interactive quizzes, and progress tracking for 10,000+ students.',
      tags: ['Next.js', 'Node.js', 'MongoDB']
    },
    {
      id: 6,
      icon: '🤖',
      category: 'AI Solution',
      title: 'Customer Support Chatbot',
      description: 'Implemented AI-powered chatbot using NLP to handle 80% of customer queries automatically, improving response time by 90%.',
      tags: ['AI/ML', 'Python', 'TensorFlow']
    }
  ];

  return (
    <div className="page-content active">
      <section className="hero" style={{ minHeight: '400px' }}>
        <div className="hero-container" style={{ gridTemplateColumns: '1fr' }}>
          <div className="hero-content" style={{ textAlign: 'center' }}>
            <h1>Our <span className="highlight">Portfolio</span></h1>
            <p>Showcasing successful projects that drive business transformation</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="portfolio-grid">
          {projects.map((project) => (
            <div key={project.id} className="portfolio-card">
              <div className="portfolio-image">{project.icon}</div>
              <div className="portfolio-content">
                <div className="portfolio-category">{project.category}</div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="tech-tags">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="tech-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <h2>Have a Project in Mind?</h2>
        <p>Let's build something amazing together</p>
        <button onClick={onContactClick} className="btn-secondary" style={{ border: 'none', cursor: 'pointer' }}>Start Your Project</button>
      </section>
    </div>
  );
};

export default Portfolio;
